/* In place of comments, this component is intended to be used by authors
 * to leave important notes about MDX content for future contributors.
 *
 * It is not rendered in the UI and is not translated.
 */
const ContributorNote = () => null;

export default ContributorNote;
